import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const HeroV4 = (props) => {
    const {
        titleList,
        titleSuffix,
        copy,
        display,
        logoInfo
    } = props;

    if (!display) return null;

    const { link, altText } = (logoInfo || {});

    const [isMoving, setIsMoving] = useState(true);

    const handler = () => {
        setIsMoving(false);
    };

    useEffect(() => {
        window.addEventListener('pageflow.next', handler);
        return () => {
            window.removeEventListener('pageflow.next', handler);
        };
    }, []);

    const TitleComponent = () => {
        if (titleList.length === 1) {
            return (
                <h2>{titleList[0]}</h2>
            );
        }
        return (
            <h2>
                <div className={cn('rotating-list', { move: isMoving })}>
                    <ul>
                        {
                            titleList.map((title, k) => (
                            // eslint-disable-next-line react/no-array-index-key
                                <li key={`title-item-${k}`}>
                                    {title}
                                </li>
                            ))
                        }
                        <li>{titleList[0]}</li>
                    </ul>
                </div>
                {titleSuffix}
            </h2>
        );
    };

    return (
        <div className={cn('ulx__aem-section', 'ulx__aem-hero__content')}>
            <img src={link} alt={altText} width="auto" height="42" />
            <TitleComponent />
            <p>{copy}</p>
        </div>
    );
};

HeroV4.propTypes = {
    logoInfo: PropTypes.shape({
        link: PropTypes.string,
        altText: PropTypes.string
    }).isRequired,
    copy: PropTypes.string.isRequired,
    display: PropTypes.bool.isRequired,
    titleList: PropTypes.arrayOf(PropTypes.string).isRequired,
    titleSuffix: PropTypes.string.isRequired
};

export default HeroV4;
